module.exports = __webpack_public_path__ + "static/balcerzak-597fe9e353a8cb92e183a2b2666d8a54.png";